import React from 'react'

const Social = () => {
  return (
    
    <div className="home__social">
        <a href="https://www.instagram.com/upcode_official/" className="home__social-icon" target="_blank" rel="noreferrer">
            <i className="uil uil-instagram"></i>
        </a>
        
        <a href="https://github.com/shubham369963" className="home__social-icon" target="_blank" rel="noreferrer">
        <i className="uil uil-github"></i>
        </a>


        <a href="https://www.linkedin.com/in/shubham-halade-22bb55206/" className="home__social-icon" target="_blank" rel="noreferrer">
        <i className="uil uil-linkedin"></i>
        </a>

    </div>
  )
}

export default Social